import { Controller } from '@hotwired/stimulus';

import nestedy from '@/modules/nestedy';

export default class extends Controller {
  connect() {
    this.links = document.querySelector('[data-links]');

    this.#nestedy();
  }

  #nestedy() {
    nestedy(this.links, {
      change: (count) => document.querySelector('[data-links-none]').classList.toggle('hidden', count > 0),
      template: '#branch-template',
    }).init();
  }
}
